<button
  class="app-btn"
  [disabled]="disabled"
  (click)="onClick()"
  (mouseover)="mouseover()"
  (mouseleave)="mouseleave()"
  [type]="type"
>
  <span><ng-content></ng-content></span>
</button>
